import React from "react";
import "./_SelectListItem.scss";

export const SelectListItem = ({
  title = "",
  material = "",
  priceText = "",
  price = 0,
  imageURL,
  onPress,
}) => {
  let titleText = title;
  titleText = material ? `${title}, ${material}` : titleText;
  const priceTextPrinted =
    price === 0 ? "Kysy hintaa" : `${priceText} ${price.toString()} €`;
  return (
    <button className="select-list-item" onClick={onPress}>
      {imageURL ? (
        <div className="image-container">
          <img src={imageURL} className="item-image" alt={title} />
        </div>
      ) : null}
      <div className="item-title-container">
        <span className="item-title">{titleText}</span>
        <span className="item-price">{priceTextPrinted}</span>
      </div>
    </button>
  );
};
